export default __webpack_public_path__ + "static/media/landing.f18920b3.jpg";